/**
 *
 * Basic BetLine win presentation. Plays symbol "win" state animations one bet line win after another.
 * It resets the symbols to normal on abort.
 *
 * For use in "idleLoop" gameRound state, usually when there is no ZeroBet.
 *
 * Created by Jonas Wålekvist on 2019-08-12.
 */
import {Timeline, TimelineLite} from "gsap";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {SASymbols} from "../symbols/SpacierArcadeReelSymbol";
import {SpacierArcade} from "../SpacierArcade";


export class BetWayWinUS implements GameRoundPresentation {

    protected _winSymbols: StateReelSymbol[];
    public stagger?:number;

    constructor(stagger?:number) {
        this.stagger = stagger;
        this._winSymbols = [];

    }

    public abort(isActive:boolean, data:SpacierArcadeParsedGameData):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        SpacierArcadeGameModuleConfig.saIndividualWinCountUp.getEndingAnimation();
        tl.add(() => {
            while (this._winSymbols.length > 0) {
                this._winSymbols.pop()!.changeState({
                    state: GameConfig.instance.SYMBOL_STATES.normal,
                    frames: [-1, -1]
                });
            }
        });

        return tl;
    }

    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        if (SpacierArcade.api.gameClientConfiguration.displayIndividualWinsInGame !== true){
            return null;
        }
        return this.getWinAnimations(data);
    }

    private getWinAnimations(data:SpacierArcadeParsedGameData):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < data.betWins.length; i++) {
            tl.add([
                this.getLineAnimation(<IBetWayWinData>data.betWins[i])
            ]);
        }
        tl.add(SpacierArcadeGameModuleConfig.saIndividualWinCountUp.getEndingAnimation());
        return tl;
    }

    private getLineAnimation(betWayWinData:IBetWayWinData):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        let winPosIndexs:number[] = [];
        let index:number = 2;
        betWayWinData.reelWinPositions[2].filter((a, i) => {if(a) winPosIndexs.push(i)});
        if(winPosIndexs.length > 0){
            index =  winPosIndexs.indexOf(3) > -1 ? 3 : betWayWinData.reelWinPositions[2].indexOf(true);
        }

        if(betWayWinData.symbol === SASymbols.S){
            for(let i:number = 1; i <= 3; i++) {
                for(let j:number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                    if(betWayWinData.reelWinPositions[i][j]) {
                        tl.add(this.getSymbolAnimation(i, j, SpacierArcadeGameConfig.instance.SYMBOL_STATES.individualWin), 0);
                    }
                }

            }
            index = 1;
        }
        else {
            for (let i: number = 0; i < betWayWinData.length; i++) {
                for (let j: number = 0; j < betWayWinData.reelWinPositions[i].length; j++) {
                    if (betWayWinData.reelWinPositions[i][j]) {
                        tl.add(this.getSymbolAnimation(i, j, SpacierArcadeGameConfig.instance.SYMBOL_STATES.individualWin), 0);
                    }
                }

            }
        }



        tl.add([
            () => SpacierArcadeGameModuleConfig.saIndividualWinCountUp.getCountUpAnimation(betWayWinData.multipliedAmount, betWayWinData.multipliedAmount, 0),
            () => SpacierArcadeGameModuleConfig.saIndividualWinCountUp.setPosition(this.getCountUpPosition(index))
        ], 0);

        return tl;
    }

    private getCountUpPosition(index:number):number{
        let returnValue:number = 0;
        index = this.checkIsFreespin()? index : index - 2;
        switch (index) {
            case 0:
                returnValue = -200;
                break;
            case 1:
                break;
            case 2:
                returnValue = 195;
                break;
        }
        return returnValue;
    }

    protected checkIsFreespin():boolean {
        return SpacierArcadeModeData.instance.mode === SpacierArcadeGameMode.FREESPIN || SpacierArcadeModeData.instance.mode === SpacierArcadeGameMode.FREESPIN_RESPIN;
    }

    private getSymbolAnimation(reelId:number, symbolId:number, state:ISymbolStateConfig):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol) {
            const symbolAnimation:Timeline = symbol.changeState({
                state : state,
                setStack : true,
                fadeInDuration : 0.0
            })!;

            tl.add([
                () => BetWayWinUS.sortSymbolDepthToTop(symbol),
                symbolAnimation,
                () => {
                    if(this._winSymbols.indexOf(symbol) === -1) {
                        this._winSymbols.push(symbol);
                    }
                }
            ]);
        }
        else {
            debugger;
            throw new Error(`Error: BetLineWin: Cannot find symbol at reel ${reelId} symbol ${symbolId}`);
        }
        return tl;
    }

    private static sortSymbolDepthToTop(symbol:StateReelSymbol):void {
        if(symbol && symbol.parent) {
            symbol.parent.addChild(symbol);
        }
    }


}